import {
  Field,
  GraphQLLocalDateTime,
  ID,
  InputType,
  ObjectType,
  registerEnumType,
} from '@warebee/shared/util-backend-only-types';
import { AgentRoleSettings } from '../policies';

@InputType()
export class ScheduleGateUsageProcessDurationSettings {
  @Field(() => GateUsageProcessType)
  process: GateUsageProcessType;

  @Field({ nullable: true, defaultValue: 1 })
  agentCount?: number;
}

@InputType()
export class ScheduleGateUsageJobDurationSettings {
  @Field(() => [ScheduleGateUsageProcessDurationSettings])
  processes: ScheduleGateUsageProcessDurationSettings[];
}

export class ScheduleGateUsageRequest {
  analyzeResultId: string;
  waitCost: number;
  startTime?: string;
  loadingAgentSettings: AgentRoleSettings;
  dockingDuration?: number;
  undockingDuration?: number;

  inverseSchedule?: boolean;
  allowSwapBetweenDeadlines?: boolean;
  jobDurationSettings?: ScheduleGateUsageJobDurationSettings;
}

@ObjectType()
export class GateUsageScheduleCost {
  @Field()
  tardiness: number;

  @Field()
  cost: number;
}

@ObjectType()
export class GateUsageScheduleRelatedJobsCost {
  @Field()
  distance: number;

  @Field()
  duration: number;

  @Field()
  cost: number;
}

@ObjectType()
export class GateUsageScheduleRelatedJobsCostSummary {
  @Field(() => GateUsageScheduleRelatedJobsCost)
  initial: GateUsageScheduleRelatedJobsCost;

  @Field(() => GateUsageScheduleRelatedJobsCost)
  scheduled: GateUsageScheduleRelatedJobsCost;
}

@ObjectType()
export class GateUsageScheduleJob {
  @Field(() => ID)
  id: string;

  @Field(() => GraphQLLocalDateTime, { nullable: true })
  deadline?: string;

  @Field()
  duration: number;
}

export enum GateUsageProcessType {
  LOADING = 'LOADING',
  HANDLING = 'HANDLING',
}

registerEnumType(GateUsageProcessType, {
  name: 'GateUsageProcessType',
});

@ObjectType()
export class GateUsageScheduleJobProcessingDuration {
  @Field(() => GateUsageProcessType)
  process: GateUsageProcessType;

  @Field()
  duration: number;

  @Field()
  agentCount: number;
}

@ObjectType()
export class GateUsageScheduleJobAssignment {
  @Field(() => GateUsageScheduleJob)
  job: GateUsageScheduleJob;

  @Field(() => GraphQLLocalDateTime)
  startTime: string;

  @Field(() => GraphQLLocalDateTime)
  completionTime: string;

  @Field({ nullable: true })
  totalDuration?: number;

  @Field({ nullable: true })
  dockingDuration?: number;

  @Field({ nullable: true })
  undockingDuration?: number;

  @Field(() => [GateUsageScheduleJobProcessingDuration], { nullable: true })
  processingDuration?: GateUsageScheduleJobProcessingDuration[];

  @Field({ nullable: true })
  waitTime?: number;

  @Field({ nullable: true })
  waitCost?: number;

  @Field({ nullable: true })
  tardiness?: number;

  @Field(() => GateUsageScheduleRelatedJobsCostSummary, { nullable: true })
  relatedJobsCost?: GateUsageScheduleRelatedJobsCostSummary;
}

@ObjectType()
export class GateUsageScheduleResource {
  @Field(() => ID)
  id: string;

  @Field(() => [GateUsageScheduleJobAssignment])
  assignments: GateUsageScheduleJobAssignment[];
}

@ObjectType()
export class GateUsageSchedule {
  @Field(() => GraphQLLocalDateTime)
  startTime: string;

  @Field(() => GraphQLLocalDateTime)
  completionTime: string;

  @Field(() => [GraphQLLocalDateTime])
  deadlines: string[];

  @Field(() => [GateUsageScheduleResource])
  resources: GateUsageScheduleResource[];

  @Field(() => GateUsageScheduleCost)
  totalCost: GateUsageScheduleCost;

  @Field(() => GateUsageScheduleCost)
  totalCostWithoutWaiting: GateUsageScheduleCost;

  @Field(() => GateUsageScheduleRelatedJobsCostSummary, { nullable: true })
  totalRelatedJobsCost?: GateUsageScheduleRelatedJobsCostSummary;
}
